require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./information-security-and-quality-assurance.json") })
        }
      }, "path---information-security-and-quality-assurance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---information-security-and-quality-assurance!./.cache/json/information-security-and-quality-assurance.json
// module id = 2131
// module chunks = 231608221292675